module.exports = __webpack_public_path__ + "img/yq8.88d885f0.png";